// Sélection des dépôts retail à interroger pour le stock (cf. table des droits), factorisée
// depuis QtyPickerRetail.tsx et RetailValidationTable.tsx qui dupliquaient la même logique :
//   - admin / N1                  → tous les dépôts retail (glob_const.retail_depots)
//   - N2                          → `customerDepot` + dépôt central SFR, dédupliqué
//   - client (tout sous-rôle)     → `customerDepot` + dépôt central SFR, dédupliqué (même règle que N2)

import glob_const from './glob_const'
import type { RetailRoleForCustomer } from '../Hooks/useRetailRoleForCustomer'

export function getRetailStockDepots(
   roleForCustomer: Pick<RetailRoleForCustomer, 'isAdmin' | 'isN1' | 'isN2'>,
   customerDepot: string | null | undefined,
): string[] {
   if (roleForCustomer.isAdmin || roleForCustomer.isN1) return glob_const.retail_depots

   // N2 et client (tout sous-rôle) partagent désormais la même règle : dépôt du
   // client + dépôt central SFR, dédupliqué. `customerDepot` vide ou déjà égal à
   // SFR → un seul dépôt affiché.
   const set = new Set<string>()
   if (customerDepot) set.add(customerDepot)
   set.add(glob_const.retail_depot_central)
   return [...set]
}
